import { ChangeEvent, useCallback, useEffect, useState } from "react";

export interface InputHookProps {
  error: string | null;
  value: string;
  onChange: (ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setError: (message: string | null) => void;
  setValue: (value: string) => void;
  validate: () => void;
}

const useInput = (initialValue?: string | null, validationRules?: [(input: string) => [boolean, string]] ): InputHookProps => {
  const [error, setError] = useState<string | null>(null);
  const [value, setValue] = useState<string>(initialValue || '');

  useEffect(() => {
    if (initialValue !== value) {
      setValue(initialValue || '');
    }
  }, [initialValue]);

  const validate = useCallback(() => {
    let errorFound = false;
    validationRules?.forEach(v => {
      if (errorFound) return;
      const [isValid, errorMessage] = v(value);
      
      if (!isValid) {
        errorFound = true;
        setError(errorMessage);
      }
    });

    if (!errorFound) setError(null);
  }, [value]);

  const onChange = useCallback((ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(ev.target.value);

    let errorFound = false;
    validationRules?.forEach(v => {
      if (errorFound) return;
      const [isValid, errorMessage] = v(ev.target.value);
      
      if (!isValid) {
        errorFound = true;
        setError(errorMessage);
      }
    });

    if (!errorFound) setError(null);
  }, []);

  return {
    error,
    onChange,
    setError,
    setValue,
    validate,
    value,
  }
};


export default useInput;
